export function isPdfFile(file: File | null): boolean {
  if (!file) return false;

  const hasPdfExtension = file.name.toLowerCase().endsWith('.pdf');
  return hasPdfExtension && (!file.type || file.type === 'application/pdf');
}

export function isImageFile(file: File | null): boolean {
  if (!file) return false;

  const acceptedExtensions = ['.jpg', '.jpeg', '.png', '.webp'];
  const lowerName = file.name.toLowerCase();
  const hasAcceptedExtension = acceptedExtensions.some((extension) => lowerName.endsWith(extension));
  return hasAcceptedExtension && (!file.type || file.type.startsWith('image/'));
}
